import React from 'react';
import { ExamErrorCode, ExamPartErrorCode, ExamPartQuestionErrorCode } from '../../../model/enum';
import { errorCodeList, getEnumLabel } from '../../../utils/enumMapper';

interface ErrorViewProps {
  errors?: ExamErrorCode[] | ExamPartErrorCode[] | ExamPartQuestionErrorCode[];
}

function ErrorView({ errors }: ErrorViewProps) {
  if (!errors || !errors.length) {
    return null;
  }
  return (
    <div className={'flex flex-col gap-y-1'}>
      {errors.map((error) => (
        <div key={error}>{getEnumLabel(error, errorCodeList)}</div>
      ))}
    </div>
  );
}

export default ErrorView;
